(() => {
  const API = "https://api.reviews.co.uk/timeline/data";
  const cards = [...document.querySelectorAll("[data-top-review-card]")];
  if (!cards.length) return;

  const card0 = cards[0];
  const store = card0.dataset.store;

  const el = document.querySelector("[data-product-review-sku]");
  const fixedSku = el?.getAttribute("data-product-review-sku")?.trim();

  if (!store || !fixedSku) return;

  const getLang = () => (document.documentElement.lang || "de").toLowerCase().split("-")[0];

  const t = (key) => {
    const lang = getLang();
    const dict = {
        verifiedBy: {de: "Verifizierte Bestellung von", en: "Verified purchase by", fr:"Achat vérifié par", nl:"Geverifieerde aankoop door" },
        anonymous:  { de:"Anonym", en:"Anonymous", fr:"Anonyme", nl:"Anoniem" }
    };
    return (dict[key] && (dict[key][lang] || dict[key].de)) || "";
  };

  const newest = (arr, n) =>
    arr
      .filter(r => +r?.rating === n)
      .sort((a, b) => Date.parse(b?.date_created || "") - Date.parse(a?.date_created || ""))[0];

  const paint = (r) => {
    cards.forEach(c => {
      if (!r) {
        c.style.display = "none";
        return;
      }

      c.style.display = "";
      c.querySelector(".rating-stars__fg")
        ?.style.setProperty("width", ((+r.rating || 0) / 5 * 100) + "%");

      const textEl = c.querySelector("[data-top-review-text]");
      if (textEl) textEl.textContent = (r.comments || "").trim();

      const name = (r.author || "").trim() || t("anonymous");

        const verifiedEl = c.querySelector("[data-top-review-verified]");
        if (verifiedEl) {
        verifiedEl.textContent = `${t("verifiedBy")} ${name}`;
        }

        //set review product color
        const sku = r.sku;
        if(!!sku){
          const colorEl = c.querySelector(`[top-review-data-color][variant_sku="${sku}"]`);
          if(!!colorEl){
            colorEl.setAttribute("active", "");
          }
        }
        //quality rating
        const qualityEl = c.querySelector("[data-top-review-quality]");
        if(!!qualityEl){
          const reviewQualityData = r.additional_ratings?.find(additonalRating => additonalRating.rating_id == 4389);
          if(!!reviewQualityData){
              //set header
              const title = reviewQualityData.question?.public_label;
              const titleEl = c.querySelector("[data-top-review-quality-title]");
              if(!!title && !!titleEl){
                titleEl.textContent = title;
              }
              //set labels
              const optionLabels = JSON.parse(reviewQualityData.question?.data) || [];
              const labelElements = c.querySelectorAll("[data-top-review-quality-label]");
              if(!!optionLabels && !!labelElements.length){
                for(let i=0; i < optionLabels.length; i++){
                  if(!!labelElements[i]){
                    labelElements[i].textContent = optionLabels[i];
                  }
                }
              }
              //set rating
              const qualityRating = reviewQualityData.rating;
              if(!!qualityRating){
                qualityEl.setAttribute("quality-rating", qualityRating);
                qualityEl.removeAttribute("loading");
              } else{
                //no quality rating, hide rating element
                qualityEl.style.display = "none";
              }
          } else {
            //no quality rating, hide rating element
            qualityEl.style.display = "none";
          }
        }
    });
  };

  async function load() {
    const lang = getLang();

    const url =
      `${API}?type=product_review` +
      `&store=${encodeURIComponent(store)}` +
      `&sort=date_desc&page=1&per_page=15` +
      `&sku=${encodeURIComponent(fixedSku)}` +
      `&lang=${encodeURIComponent(lang)}` +
      `&widget=polaris`;

      console.log(url , 'url');
    try {
      const res = await fetch(url, { cache: "no-store", headers: { accept: "application/json" } });
      const data = res.ok ? await res.json().catch(() => ({})) : {};

      const reviews = Array.isArray(data?.timeline)
        ? data.timeline.map(x => x?._source).filter(Boolean)
        : [];

      paint(newest(reviews, 5) || newest(reviews, 4) || null);
    } catch {
      paint(null);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", load);
  } else {
    load();
  }

  let timer;
  const scheduleLoad = () => {
    clearTimeout(timer);
    timer = setTimeout(load, 150);
  };

  const obs = new MutationObserver(scheduleLoad);
  obs.observe(document.documentElement, { attributes: true, attributeFilter: ["lang"] });


/*  const obs = new MutationObserver(load);
  obs.observe(document.documentElement, { attributes: true, attributeFilter: ["lang"] });*/
})();
